import type { ApplyChannel } from '@/components/v2/tools/amazon-listing/RemakeApply/RemakeApplyChannelPicker'
import { AddToProductSlotGrid, type SlotFill } from './AddToProductSlotGrid'
import type { MediaSize } from './MediaSizeToggle'
import type { AddToProductTarget } from '../types'

interface AllChannelsViewProps {
  channels: ApplyChannel[]
  filledByChannel: Record<string, Record<number, SlotFill>>
  size?: MediaSize
  onDelete?: (target: AddToProductTarget) => void
}

/**
 * Stacked, per-channel slot grids. One labelled section per channel; the
 * channel name is the section heading, optionally followed by a monospace
 * external identifier when present on the channel.
 */
export function AllChannelsView({
  channels,
  filledByChannel,
  size = 'M',
  onDelete,
}: AllChannelsViewProps) {
  return (
    <div className="space-y-6">
      {channels.map((c) => (
        <section key={c.id}>
          <h4 className="text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2 flex items-center gap-2">
            <span>{c.name}</span>
            {c.externalChannelId && (
              <span className="font-mono text-xs text-neutral-500">
                {c.externalChannelId}
              </span>
            )}
          </h4>
          <AddToProductSlotGrid
            filled={filledByChannel[c.id] ?? {}}
            channelId={c.id}
            size={size}
            onDelete={onDelete}
          />
        </section>
      ))}
    </div>
  )
}
